module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifDemi.18a272b2.otf";